var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapSettingsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1174,
    height: 1178,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1475,
    y: 1232,
    width: 1174,
    height: 1178
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1475 -1232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1476 1822C1476 1498.91 1737.69 1237 2060.5 1237 2383.31 1237 2645 1498.91 2645 1822 2645 2145.09 2383.31 2407 2060.5 2407 1737.69 2407 1476 2145.09 1476 1822Z",
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1769 1487C1769 1460.49 1790.49 1439 1817 1439L1817 1439C1843.51 1439 1865 1460.49 1865 1487L1865 2157C1865 2183.51 1843.51 2205 1817 2205 1790.49 2205 1769 2183.51 1769 2157Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1731.5 1647.5C1731.5 1599.45 1770.45 1560.5 1818.5 1560.5 1866.55 1560.5 1905.5 1599.45 1905.5 1647.5 1905.5 1695.55 1866.55 1734.5 1818.5 1734.5 1770.45 1734.5 1731.5 1695.55 1731.5 1647.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 41.25,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283.5 1488.01C2283.5 1461.22 2305.22 1439.5 2332 1439.5L2332 1439.5C2358.79 1439.5 2380.51 1461.22 2380.51 1488.01L2380.51 2157C2380.51 2183.78 2358.79 2205.5 2332 2205.5L2332 2205.5C2305.22 2205.5 2283.5 2183.78 2283.5 2157Z",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2245.5 1647.5C2245.5 1599.45 2284.45 1560.5 2332.5 1560.5 2380.55 1560.5 2419.5 1599.45 2419.5 1647.5 2419.5 1695.55 2380.55 1734.5 2332.5 1734.5 2284.45 1734.5 2245.5 1695.55 2245.5 1647.5Z",
    stroke: "#FFFFFF",
    strokeWidth: 41.25,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2123 2157C2123 2183.51 2101.51 2205 2075 2205L2075 2205C2048.49 2205 2027 2183.51 2027 2157L2027 1487C2027 1460.49 2048.49 1439 2075 1439 2101.51 1439 2123 1460.49 2123 1487Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2161.5 1998C2161.5 2045.77 2122.55 2084.5 2074.5 2084.5 2026.45 2084.5 1987.5 2045.77 1987.5 1998 1987.5 1950.23 2026.45 1911.5 2074.5 1911.5 2122.55 1911.5 2161.5 1950.23 2161.5 1998Z",
    stroke: "#FFFFFF",
    strokeWidth: 41.25,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#404040",
    fillRule: "evenodd",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSettingsActive);
export default __webpack_public_path__ + "static/media/map-settings-active.1b43729bb1b86726593e0adb4d85f851.svg";
export { ForwardRef as ReactComponent };